import { render, staticRenderFns } from "./CkEditorInput.vue?vue&type=template&id=a7123908&"
import script from "./CkEditorInput.vue?vue&type=script&lang=js&"
export * from "./CkEditorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports